import React, { memo } from "react";
import { Settings } from "../../../settings";
import { Container } from "@pixi/react";
import FreeSpinMaskReel from "../FreeSpinMaskReel/FreeSpinMaskReel";
import { useDimensions } from "../../../Contexts/DimensionsContext";
import { useReelRefs } from "../../../Contexts/ReelRefsContext";
import FreeSpinCounter from "../../../Components/Animations/FreeSpin/FreeSpinCounter/FreeSpinCounter";

const FreeSpinMaskReelSet = memo(() => {
  const { symbolWidth, symbolHeight, reelSpacing } = useDimensions();
  const { freeSpinReelRefs, freeSpinOverlayReelRefs, maskReelRefs } =
    useReelRefs();

  const reels = Array.from({ length: Settings.REEL_COUNT }, (_, idx) => idx);

  return (
    <Container
      name="free_spin_mask_overlay"
      zIndex={7}
      y={-symbolHeight * (0.5 * Settings.SYMBOLS_VISIBLE - 0.5)}
    >
      {reels.map((index) => (
        <FreeSpinMaskReel
          key={index}
          index={index}
          symbolWidth={symbolWidth}
          symbolHeight={symbolHeight}
          reelSpacing={reelSpacing}
          freeSpinReelRefs={freeSpinReelRefs}
          freeSpinOverlayReelRefs={freeSpinOverlayReelRefs}
          ref={(el) => {
            maskReelRefs.current[index] = el;
          }}
        />
      ))}
      <FreeSpinCounter />
    </Container>
  );
});

export default FreeSpinMaskReelSet;
